import { res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { dateFormat } from "@/BaseComponent";
export default {
    async getMonitList(status: number | null, page: number, size: number, filterList: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/monitoring",
                {
                    page,
                    size,
                    searchType: filterList.searchType,
                    sns: filterList.sns,
                    type: filterList.type,
                    resultType: filterList.resultType,
                    resultDetailType: filterList.resultDetailType,
                    nation: filterList.nation,
                    searchContent: filterList.searchContent,
                    startDate: dateFormat(new Date(filterList.date[0])),
                    endDate: dateFormat(new Date(filterList.date[1])),
                    status,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getStatusCnt(status: number | null, page: number, size: number, filterList: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/monitoring/status/cnt",
                {
                    page,
                    size,
                    searchType: filterList.searchType,
                    sns: filterList.sns,
                    type: filterList.type,
                    resultType: filterList.resultType,
                    resultDetailType: filterList.resultDetailType,
                    nation: filterList.nation,
                    searchContent: filterList.searchContent,
                    startDate: dateFormat(new Date(filterList.date[0])),
                    endDate: dateFormat(new Date(filterList.date[1])),
                    status,
                },
                { withCredentials: false },
            );
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async saveMonitoring(
        idx: number,
        memo: string,
        type: number,
        detailType: number,
        detailContent: string,
        status: number,
        hour: number,
        isMonitoring: number,
    ): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/search/monitoring/status/update`,
                {
                    idx,
                    memo,
                    type,
                    detailType,
                    detailContent,
                    status,
                    hour,
                    isMonitoring,
                },
                { withCredentials: false },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async updateMonitorings(idxList: string, status: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/search/monitoring/multi/status/update`,
                {
                    idxList,
                    status,
                },
                { withCredentials: false },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async deleteMonitorings(idxList: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                `/search/monitoring/multi/delete`,
                {
                    idxList,
                },
                { withCredentials: false },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getMonitoringLog(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/search/monitoring/status/list/` + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },

    async updateMonitoringsForType(params: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/search/monitoring/multi/type`, params, { withCredentials: false });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
